module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 8h-2V2c0-1.106-.894-2-2-2H6C2.692 0 0 2.692 0 6v20c0 3.308 2.692 6 6 6h24c1.106 0 2-.894 2-2V10c0-1.106-.894-2-2-2zM4 6a2 2 0 0 1 2-2h18v4H6a2 2 0 0 1-2-2zm22 15a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/wallet-1.js
// module id = 1493
// module chunks = 14